import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import SlimRelatedProductsCarousel from '~/components/Organisms/SlimRelatedProducts.vue';
import { useProductStore } from '~/composables/_next/stores/useProductStore';
import { useAttraqt } from '@/composables/_next/useAttraqt';
export default /*#__PURE__*/_defineComponent({
  __name: 'UpsellProductsOrganism',
  setup: function setup(__props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useProductStore = useProductStore(),
      selectedVariant = _useProductStore.selectedVariant,
      masterVariant = _useProductStore.masterVariant;
    var _useAttraqt = useAttraqt(),
      fetchUpsellProducts = _useAttraqt.fetchUpsellProducts;
    var _useLazyAsyncData = useLazyAsyncData('fetch-upsell-products', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (masterVariant.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return fetchUpsellProducts([masterVariant.value.sku]);
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), {
        watch: [masterVariant],
        server: false
      }),
      upsellProducts = _useLazyAsyncData.data,
      error = _useLazyAsyncData.error;
    var inStockAttribute = computed(function () {
      var _selectedVariant$valu, _selectedVariant$valu2;
      return (_selectedVariant$valu = selectedVariant.value) === null || _selectedVariant$valu === void 0 ? void 0 : (_selectedVariant$valu2 = _selectedVariant$valu.attributesRaw) === null || _selectedVariant$valu2 === void 0 ? void 0 : _selectedVariant$valu2.find(function (attribute) {
        return attribute.name === 'is-sellable';
      });
    });
    var isInStock = computed(function () {
      var _inStockAttribute$val;
      return ((_inStockAttribute$val = inStockAttribute.value) === null || _inStockAttribute$val === void 0 ? void 0 : _inStockAttribute$val.value.key) !== 'OutOfStock';
    });
    var upsellProductsData = computed(function () {
      var _upsellProducts$value, _upsellProducts$value2, _upsellProducts$value3;
      return {
        attraqtInformation: {
          widgetId: (_upsellProducts$value = upsellProducts.value) === null || _upsellProducts$value === void 0 ? void 0 : _upsellProducts$value.widgetId,
          otherAttraqtData: upsellProducts.value
        },
        title: isInStock.value ? translate('attraqt.isInStock') : translate('attraqt.isOutOfStock'),
        description: (_upsellProducts$value2 = upsellProducts.value) === null || _upsellProducts$value2 === void 0 ? void 0 : _upsellProducts$value2.widget.title,
        listOfProducts: upsellProducts === null || upsellProducts === void 0 ? void 0 : (_upsellProducts$value3 = upsellProducts.value) === null || _upsellProducts$value3 === void 0 ? void 0 : _upsellProducts$value3.recommendations.map(function (rec) {
          return rec.id;
        })
      };
    });
    return {
      __sfc: true,
      translate: translate,
      selectedVariant: selectedVariant,
      masterVariant: masterVariant,
      fetchUpsellProducts: fetchUpsellProducts,
      upsellProducts: upsellProducts,
      error: error,
      inStockAttribute: inStockAttribute,
      isInStock: isInStock,
      upsellProductsData: upsellProductsData,
      SlimRelatedProductsCarousel: SlimRelatedProductsCarousel
    };
  }
});